export const FARM_NAME_FIELD_NAME = 'name';

export const CLIENT_FIELD_NAME = 'client';

export const TEST_ID = 'farmFormFields';
